export default __webpack_public_path__ + "static/media/2b02a3a6ea55b0cbddb84b97c252bb571600812841314.1fbefda2.webp";